// @ts-nocheck
import styled from 'styled-components';

export const MapTypeSwitchStyle = styled.div`
  display: flex;
  flex-direction: column;
  .singleSelectWrapper {
    min-width: 180px;
  }
  .innerControls {
    &__cartographyLevelSelector {
      width: 94%;
    }

    &__heatmapSliderWrapper {
      margin-top: 20px;
    }
  }
  .mapInnerControls__section {
    &__radioButtonGroupWrapper {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    &__radioButtonOption {
      display: flex;
      flex-direction: column;
      gap: 6px;
      width: 200px;
      &__header {
        display: flex;
        gap: 8px;
        &__title {
          color: ${props => props.theme.uiColors.textBodyDefault};
          font-size: 14px;
          letter-spacing: 0;
          line-height: 16px;
        }
      }
      &__body {
        color: ${props => props.theme.uiColors.selectorDescription};
        padding-left: 24px;
        font-size: 10px;
        letter-spacing: 0;
        line-height: 14px;
      }
      &__additionalSettings {
        display: flex;
        flex-direction: column;
        &__divider {
          height: 1px;
          width: auto;
          background-color: rgba(160,178,211,0.5);
        }
      }
    }
  }
`;
